import { Box, Stack, SxProps } from "@mui/material";
import { Colors } from "@src/gatsby-theme-material-ui-top-layout/colors-twentyfive";

import React, { forwardRef } from "react";

interface Props {
  children: any;
  sx?: SxProps;
}

const GlassContainer = forwardRef(function GlassContainer(props: Props, ref) {
  const { children, sx = {} } = props;

  return (
    <Box
      ref={ref}
      sx={{
        position: "relative",
        borderRadius: "15px",
        background: `linear-gradient(108deg, ${Colors.InfoMain}10 -10%, ${Colors.InfoMain}2B 51.18%, ${Colors.InfoMain}1A 110%)`,
        padding: "15px",
        width: "100%",
        ...sx,
      }}
    >
      <Box
        sx={{
          position: "absolute",
          inset: 0,

          borderRadius: "15px",
          border: "1px solid transparent",
          background: `linear-gradient(-100deg, rgba(255, 255, 255, 0.00) 0%, ${Colors.InfoMain} 51.18%, rgba(255, 255, 255, 0.00) 99.94%)`,
          mask: "linear-gradient(#000 0 0) padding-box, linear-gradient(#000 0 0)",
          maskComposite: "exclude",
        }}
      />
      {children}
    </Box>
  );
});

export default GlassContainer;
